import { useState } from 'react';
import '../styles/checklist.css';

interface ChecklistStep {
  title: string;
  content: string;
  image?: string;
  images?: string[];
}

interface ChecklistProps {
  onComplete: () => void;
}

const CHECKLIST_STEPS: ChecklistStep[] = [
  {
    title: 'VR Brillen Aanzetten',
    content: 'Zet de VR brillen aan door aan de zijkant het knopje 3 tellen ingedrukt te houden. Er gaat dan een lampje branden. Het lampje moet wit worden. Na 5 seconden gaat er een wit lampje voorop de VR bril aan zolang deze niet in de playspace zit.',
    images: ['./checklist-images/step_7.jpg', './checklist-images/step_0.jpg']
  },
  {
    title: 'Batterijen Vervangen',
    content: 'Verwissel alle Batterijen voor een nieuwe van de oplader. Controleer of het lampje onder de batterij brandt. Zo niet, druk dan het knopje aan de zijkant van de batterijhouder even kort in. Je hoort dan een piepje en het lampje gaat branden.',
    images: [ './checklist-images/step_9.jpg', './checklist-images/step_8.jpg', './checklist-images/step_11.jpg' ]
  },
  {
    title: 'Playspace Controleren',
    content: 'Controleer of de playspace zichtbaar is door in de VR bril te kijken. Indien niet zichtbaar: Tik snel 3x met je vinger tegen de zijkant van de VR-bril. Dit zorgt ervoor dat hij opnieuw zijn omgeving scant.',
    images: ['./checklist-images/Playspace.jpeg', './checklist-images/3Tap.jpeg']
  },
  {
    title: 'Koptelefoons Aanzetten',
    content: 'Verwijder de USB kabel en zorg dat de Koptelefoons aanstaan door het knopje naar boven te schuiven. Je moet een wit lampje zien branden.',
    image: './checklist-images/step_4.jpg'
  },
  {
    title: 'Schoonmaak - Leren Onderdelen + Lenzen',
    content: 'Gebruik de alcohol wipes om de lenzen van de VR Bril goed schoon te maken. Maak ook alle leren onderdelen schoon door daar kort overheen te wipen.',
    image: './checklist-images/BrilSchoon.jpeg'
  }
];

export default function Checklist({ onComplete }: ChecklistProps) {
  const [enlargedImage, setEnlargedImage] = useState<string | null>(null);

  const handleImageClick = (imageSrc: string) => {
    setEnlargedImage(imageSrc);
  };

  const handleCloseEnlargedImage = () => {
    setEnlargedImage(null);
  };
  return (
    <div className="checklist-screen">
      <div className="checklist-modal">
        <div className="checklist-header">
          <h2>Setup Checklist</h2>
          <p>Please complete the following steps before starting</p>
        </div>
        <div className="checklist-body">
          {CHECKLIST_STEPS.map((step, index) => (
            <div key={index} className="checklist-step">
              {/* Text content on the left */}
              <div className="checklist-step-text">
                <div className="checklist-step-number">{index + 1}</div>
                <div className="checklist-step-title">{step.title}</div>
                <div className="checklist-step-content">{step.content}</div>
              </div>

              {/* Images on the right */}
              {(step.image || (step.images && step.images.length > 0)) && (
                <div className="checklist-step-media">
                  {/* Display single image if provided */}
                  {step.image && !step.images && (
                    <img
                      src={step.image}
                      alt={step.title}
                      className="checklist-step-image clickable"
                      onClick={() => handleImageClick(step.image!)}
                    />
                  )}

                  {/* Display multiple images if provided */}
                  {step.images && step.images.length > 0 && (
                    <div className="checklist-step-images">
                      {step.images.map((img, imgIndex) => (
                        <img
                          key={imgIndex}
                          src={img}
                          alt={`${step.title} - ${imgIndex + 1}`}
                          className="checklist-step-image clickable"
                          onClick={() => handleImageClick(img)}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="checklist-footer">
          <button className="btn btn-primary" onClick={onComplete}>
            I have completed all steps
          </button>
        </div>
      </div>

      {/* Image Popup Modal */}
      {enlargedImage && (
        <div className="image-popup-overlay" onClick={handleCloseEnlargedImage}>
          <div className="image-popup-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={enlargedImage}
              alt="Enlarged view"
              className="image-popup-enlarged"
              onClick={handleCloseEnlargedImage}
            />
          </div>
        </div>
      )}
    </div>
  );
}
